import { render, staticRenderFns } from "./TruckListUpload.vue?vue&type=template&id=05db0497&scoped=true&"
import script from "./TruckListUpload.vue?vue&type=script&lang=js&"
export * from "./TruckListUpload.vue?vue&type=script&lang=js&"
import style1 from "./TruckListUpload.vue?vue&type=style&index=1&id=05db0497&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db0497",
  null
  
)

export default component.exports